export default function authHeader(apikey=null) {
  let key = apikey || localStorage.getItem("apikey");
  //console.log("authHeader:", key)
  if (key) {
    return { "Authorization": key };
  } else {
    return {};
  }
}
